module.exports = __webpack_public_path__ + "b6cb4fd9a9aeb6914334bc814ec7bb92.png";